<template>
	<section>
		<div v-if="$route.path != '/productInformation/productControl/addProduct'">
			<el-form :inline="true" class="toolbar" style="padding-bottom: 0px; min-width:900px;">
				<el-form-item label="单品编号:" label-width="80px">
					<el-input v-model="query.productId"></el-input>
				</el-form-item>
				<el-form-item label="名称:" label-width="50px">
					<el-input v-model="query.productName"></el-input>
				</el-form-item>
				<el-form-item label="分类:" label-width="60px">
					<el-select placeholder="请选择分类" v-model="query.productClass">
						<el-option v-for="option in ProductClass" :value="option.Value" :label="option.Key">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="种类:" label-width="60px">
					<el-select placeholder="请选择种类" v-model="query.productCategory">
						<el-option v-for="option in Category" :value="option.Id" :label="option.ParmName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" icon="search" @click="search">搜索</el-button>
				<el-button type="primary" icon="arrow-down" @click="download">导出</el-button>
			</el-form>
			<div class="toolbar" style="padding-top: 15px">
				<el-button type="primary" size="small" icon="plus" v-on:click="addProduct">新建单品</el-button>
				<!--<router-link :to="{path:'OlCourseMaterial',query: {id:'11'}}">deeee</router-link>-->
			</div>
			<div>
				<el-table :data="List" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="ProductId" label="单品ID" width="100"></el-table-column>
					<el-table-column prop="ProCode" label="单品编号" width="200"></el-table-column>
					<el-table-column prop="ProName" label="名称" width="200"></el-table-column>
					<el-table-column label="销量" prop='OrderNum' width="100"></el-table-column>
					<el-table-column prop="ProClassName" label="分类" width="100"></el-table-column>
					<el-table-column prop="ProAttributeName" label="属性" width="100"></el-table-column>
					<el-table-column prop="ProCategoryName" label="种类" width="100"></el-table-column>
					<el-table-column prop="ProTypeName" label="类型/科目" width="100"></el-table-column>
					<el-table-column prop="ProBrandName" label="品牌" width="200"></el-table-column>
					<el-table-column prop="ProSpecName" label="规格/类别" width="200"></el-table-column>
					<el-table-column prop="ProModelNumName" label="型号/册数" width="200"></el-table-column>
					<el-table-column prop="AddUserName" label="新建人" width="200"></el-table-column>
					<el-table-column prop="AddTime" label="新建时间" width="200"></el-table-column>
					<el-table-column label="操作" width="350px" fixed="right">
						<template scope="scope">
							<el-button size="small" @click="ProVisit(scope.$index, scope.row)" icon="view" type="success">查看</el-button>
							<el-button size="small" @click="handleEdit(scope.$index, scope.row)" :disabled="(scope.row.btnVue&4)<=0" icon="edit" type="primary">修改</el-button>
							<el-button size="small" @click="delProduct(scope.$index, scope.row)" :disabled="(scope.row.btnVue&8)<=0" icon="delete" type="danger">删除</el-button>
							<el-button size="small" @click="forbidden(scope.$index, scope.row)" :disabled="(scope.row.btnVue&32)<=0" icon="circle-cross" type="warning">禁用</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-col :span="24" class='btm-action'>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
				</el-pagination>
			</el-col>
		</div>
		<div v-else>
			<transition>
				<router-view></router-view>
			</transition>
		</div>
	</section>
</template>
<script>
import product from "./productControl.js";
module.exports = product;
</script>
<style lang="scss" scoped>
.btm-action {
  display: flex;
  justify-content: center;
  margin: 5px 0px;
}
</style>


// WEBPACK FOOTER //
// productControl.vue?53de21b4